import { http, HttpResponse } from 'msw';
import { ddApiDevice } from '../gallery/dummydata/ddDevice';
import { ddDMSConfig } from '../gallery/dummydata/ddDMSConfig';
import { ddApiLocation } from '../gallery/dummydata/ddLocations';
import { handlersGtfs } from './handlers-gtfs';
import { handlersSmhi } from './handlers-smhi';

export const handlers = [
  ...handlersSmhi,
  ...handlersGtfs,

  http.get('https://api.viu.dev.allbin.se/public/devices/:deviceId', () => {
    return HttpResponse.json(ddApiDevice);
  }),

  http.get(
    `https://api.viu.dev.allbin.se/public/devices/:deviceId/config`,
    () => HttpResponse.json(ddDMSConfig),
  ),

  http.get(
    `https://api.viu.dev.allbin.se/public/devices/:deviceId/location`,
    () => HttpResponse.json(ddApiLocation),
  ),

  http.get(
    `https://api.viu.dev.allbin.se/public/devices/:deviceId/announcements`,
    () => HttpResponse.json([]), // TODO ddApiAnnouncements
  ),

  http.get(
    `https://api.viu.dev.allbin.se/public/devices/:deviceId/attachments`,
    () => HttpResponse.json([]), // TODO ddApiAttachments
  ),

  http.get(
    `https://api.viu.dev.allbin.se/public/devices/:deviceId/embedded-urls`,
    () => HttpResponse.json([]), // TODO ddApiEmbeddedUrls
  ),
];
